import store from 'redux/store'
import { sessionCountOnline } from 'redux/actions/sessions'

import {
  reportsGetStatictics,
  reportsActiveNew,
  reportsActionFulfilled,
  reportsActivesReadDone,
  reportsActivesUnreadDone,
  reportsActivesDeleteDone,
  reportsArchivedUnboxDone,
} from 'redux/actions/reports'
import {
  summonsGetStatictics,
  summonsGetIssued,
  summonApproveSuccessful,
  summonArchiveSuccessful,
} from 'redux/actions/summons'
import { trackerGetStarted } from 'redux/actions/trackers'
import { toursGetTodayCount } from 'redux/actions/tours'

let storage = JSON.parse(localStorage.getItem('guardexpert_logon'))

export function mqttHandlers(topic, payload) {
  const splittedTopic = topic.split('/')
  let mainTopic = splittedTopic[1]
  const msgTarget = splittedTopic[0]

  storage = JSON.parse(localStorage.getItem('guardexpert_logon'))
  if (!storage.info) {
    return
  }

  if (splittedTopic[0] === 'TOUR' || splittedTopic[0] === 'PANIC') {
    mainTopic = splittedTopic[0]
  } else if (
    msgTarget !== `${storage.info.userId}` &&
    msgTarget !== 'BROADCAST'
  ) {
    return
  }

  switch (mainTopic) {
    case 'DEVICE':
      sessionsReceiver(topic, JSON.parse(payload))
      break
    case 'REPORT':
      reportsReceiver(topic, JSON.parse(payload))
      break
    case 'SUMMON':
      summonsReceiver(topic, JSON.parse(payload))
      break
    case 'TOUR':
      toursReceiver(topic, JSON.parse(payload))
      break
    case 'PANIC':
      panicsReceiver(topic, JSON.parse(payload))
      break
    default:
  }
}

function sessionsReceiver(topic) {
  storage = JSON.parse(localStorage.getItem('guardexpert_logon'))
  const id = storage.info.userId
  switch (topic) {
    case 'BROADCAST/DEVICE/LOGIN':
    case `${id}/DEVICE/LOGIN`:
      store.dispatch(sessionCountOnline())
      break
    case 'BROADCAST/DEVICE/LOGOUT':
    case `${id}/DEVICE/LOGOUT`:
      store.dispatch(sessionCountOnline())
      break
    default:
  }
}

function reportsReceiver(topic, payload) {
  storage = JSON.parse(localStorage.getItem('guardexpert_logon'))
  const id = storage.info.userId
  /* eslint-disable no-fallthrough */
  switch (topic) {
    case 'BROADCAST/REPORT/NEW':
    case `${id}/REPORT/NEW`:
      store.dispatch(reportsGetStatictics())
      store.dispatch(reportsActiveNew(payload))
      break

    case 'BROADCAST/REPORT/ACTION':
    case `${id}/REPORT/ACTION`:
      store.dispatch(reportsActionFulfilled(payload))
      break

    case 'BROADCAST/REPORT/READ':
    case `${id}/REPORT/READ`:
      // console.log("REPORT/READ :/n", payload)
      store.dispatch(reportsActivesReadDone(payload))
      break

    case 'BROADCAST/REPORT/UNREAD':
    case `${id}/REPORT/UNREAD`:
      // console.log("REPORT/UNREAD :/n", payload)
      store.dispatch(reportsActivesUnreadDone(payload))
      break

    case 'BROADCAST/REPORT/ARCHIVED':
    case `${id}/REPORT/ARCHIVED`:
      // console.log("REPORT/ARCHIVED :/n", payload)
      store.dispatch(reportsActivesDeleteDone(payload))
      break

    case 'BROADCAST/REPORT/UNARCHIVED':
    case `${id}/REPORT/UNARCHIVED`:
      console.log('REPORT/UNARCHIVED :/n', payload)
      store.dispatch(reportsArchivedUnboxDone(payload))
      break
  }
}

function summonsReceiver(topic, payload) {
  storage = JSON.parse(localStorage.getItem('guardexpert_logon'))
  const id = storage.info.userId

  switch (topic) {
    case 'BROADCAST/SUMMON/NEW':
    case `${id}/SUMMON/NEW`:
      store.dispatch(summonsGetStatictics())
      store.dispatch(summonsGetIssued(0, 10))
      break

    case 'BROADCAST/SUMMON/ARCHIVED':
    case `${id}/SUMMON/ARCHIVED`:
      store.dispatch(summonArchiveSuccessful(payload))
      break

    case 'BROADCAST/SUMMON/APPROVED':
    case `${id}/SUMMON/APPROVED`:
      store.dispatch(summonApproveSuccessful(payload))
      break

    case 'BROADCAST/SUMMON/REJECTED':
    case `${id} /SUMMON/REJECTED`:
      // console.log(`SUMMON/REJECTED > \n`, payload)
      break

    case 'BROADCAST/SUMMON/DELETE':
    case `${id}/SUMMON/DELETE`:
      // console.log(`SUMMON/DELETE > \n`, payload)
      break
    default:
  }
}

function toursReceiver(topic, payload) {
  switch (topic) {
    case 'TOUR/START':
      dispatchTourStart(payload.tracker_id)
      break
    case 'TOUR/POSITION':
      dispatchTourRoute(payload)
      break
    case 'TOUR/STOP':
      dispatchTourStop(payload.tracker_id)
      store.dispatch(toursGetTodayCount())
      break
    case `TOUR/POINT/${payload.tracker_id}`:
      dispatchTourVisited(payload)
      break
    default:
  }
}

function panicsReceiver(topic, data) {
  let state
  let trackerId
  switch (topic) {
    case 'PANIC/START':
      state = data.state
      trackerId = data.tracker_id
      dispatchPanicStart(trackerId, state)
      break
    case 'PANIC/POSITION':
      dispatchPanicRoute(data)
      break
    case 'PANIC/STOP':
      trackerId = data.tracker.id
      dispatchPanicStop(trackerId)
      break
    default:
  }
}

/** ====================================================
 *                INTERNAL DISPATCHERS
 **====================================================
 */

function dispatchTourStart(trackerId) {
  store.dispatch(trackerGetStarted(trackerId))
}
function dispatchTourStop(trackerId) {
  store.dispatch({
    type: 'TRACKERS_TOUR_END',
    payload: {
      data: trackerId,
      error: null,
    },
  })
}
function dispatchTourRoute(payload) {
  store.dispatch({
    type: 'TRACKERS_TOUR_ROUTE',
    payload: {
      data: payload,
      error: null,
    },
  })
}
function dispatchTourVisited(state) {
  store.dispatch({
    type: 'TRACKERS_TOUR_VISITED',
    payload: {
      data: state,
      error: null,
    },
  })
}

function dispatchPanicStart(trackerId, state) {
  if (!state.tracker[trackerId].isTour) {
    return store.dispatch(trackerGetStarted(state.tracker[trackerId].id))
  }
  store.dispatch({
    type: 'TRACKERS_PANIC_START',
    payload: {
      data: { info: state, trackerId: trackerId },
      error: null,
    },
  })
}
function dispatchPanicStop(trackerId) {
  // console.log("__dispatch_panic_stop > trackerId:", trackerId)
  store.dispatch({
    type: 'TRACKERS_PANIC_STOP',
    payload: {
      data: trackerId,
      error: null,
    },
  })
}
function dispatchPanicRoute(data) {
  // console.log("__dispatch_panic_route > data:", data)
  store.dispatch({
    type: 'TRACKERS_TOUR_ROUTE',
    payload: {
      data: data,
      error: null,
    },
  })
}
